import React, { Component } from 'react';
import moment from 'moment';
import { hour_list, Status, LOADING_CIRCLE } from 'common/utils/constants';
import Modal from 'components/shared/Modal/Modal';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import { DayPicker } from 'components/shared/ReactDayPicker';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import classNames from 'classnames';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { connect } from 'react-redux';
import { DeviceVersionList } from './DeviceVersionList/DeviceVersionList';
import './SoftwareDownloadModal.css';

class SoftwareDownloadModal extends Component {
  constructor(props) {
    super(props);

    let time = moment();
    time.add(1, 'hour');
    this.state = {
      selectedDay: new Date(Date.now()),
      selectedIndex: 0,
      dateText: time.format('MMM D, YYYY'),
      timeText: time.format('hh:mm a'),
      timeWindowActive: false,
      dateWindowActive: true,
      stage: 'LIST',
      searchString: '',
      dateValid: true
    };

    this.handleDayClick = this.handleDayClick.bind(this);
    this.selectTimeOnClick = this.selectTimeOnClick.bind(this);
  }

  handleDayClick(day) {
    let mmnt = moment(day.toISOString());
    this.setState({
      dateWindowActive: true,
      timeWindowActive: false,
      selectedDay: day,
      dateText: mmnt.format('MMM D, YYYY')
    });
  }

  selectTimeOnClick(time) {
    this.setState({ timeText: time, timeWindowActive: false });
  }

  componentDidUpdate() {
    let datetime = moment(this.state.dateText);
    let mmntTime = moment(this.state.timeText, 'hh:mm a');
    datetime.hour(mmntTime.hour());
    datetime.minute(mmntTime.minute());
    let now = moment();
    let isValid = datetime.isAfter(now, 'hour');
    if (this.state.dateValid !== isValid) {
      this.setState({ dateValid: isValid });
    }
  }

  render() {
    let list = null;
    let calender = null;
    let buttons1 = null;
    let buttons2 = null;

    switch (this.state.stage) {
      case 'LIST':
        buttons1 = (
          <div className={'DeviceVersionView_Buttons_Install_Div'}>
            {this.props.availableSwVersionList && this.props.availableSwVersionList.length > 0 && (
              <button
                className={'DeviceVersionView_Buttons_Schedule Global_RoundedButton'}
                onClick={() => {
                  this.setState({ stage: 'CALENDAR' });
                }}
              >
                <IconAndText
                  img={IconLoader.icon_schedule_bttn}
                  hoverImg={IconLoader.icon_schedule_bttn_hover}
                  className="DeviceVersionView_Buttons_Icon"
                  text={'Install it later'}
                />
              </button>
            )}
            {this.props.actionPending ? (
              <button className={'DeviceVersionView_Buttons_Install Global_RoundedButton'}>
                <img
                  alt={'loading icon'}
                  className="DeviceConfigTable_Status_LoadingIcon"
                  src={IconLoader.icon_spinner_small}
                />
              </button>
            ) : (
              <button
                type="submit"
                id="singleUpgradeFormSubmit"
                name="singleUpgradeFormSubmitName"
                disabled={!this.props.availableSwVersionList || this.props.availableSwVersionList.length === 0}
                className={'DeviceVersionView_Buttons_Install Global_RoundedButton'}
                onClick={() => {
                  //
                  window._mfq = window._mfq || [];
                  try {
                    window._mfq.push(['formSubmitAttempt', '#singleUpgradeForm']);
                    this.props.availableSwVersionList &&
                      this.props.installNowOnClick(
                        this.props.availableSwVersionList[this.state.selectedIndex].sw_identifier
                      );
                    window._mfq.push(['formSubmitSuccess', '#singleUpgradeForm']);
                  } catch (error) {
                    window._mfq.push(['formSubmitFailure', '#singleUpgradeForm']);
                  }
                }}
              >
                Install Now
              </button>
            )}
          </div>
        );
        break;
      case 'CALENDAR':
        let dateClass = this.state.dateWindowActive
          ? 'DeviceVersionView_Buttons_Schedule_Date DeviceVersionView_Buttons_Schedule_Active'
          : 'DeviceVersionView_Buttons_Schedule_Date';
        let timeClass = this.state.timeWindowActive
          ? 'DeviceVersionView_Buttons_Schedule_Time DeviceVersionView_Buttons_Schedule_Active'
          : 'DeviceVersionView_Buttons_Schedule_Time';
        buttons2 = (
          <div className={'DeviceVersionView_Buttons_Schedule_Div'}>
            <div className="DeviceVersionView_Buttons_Schedule_Div_Left">
              <div className={dateClass}>
                <input
                  type="text"
                  className="DeviceVersionView_Buttons_Schedule_Div_Left_Text"
                  value={this.state.dateText}
                  onChange={(evt) => {
                    let newState = {};
                    try {
                      let mmnt = moment(evt.target.value, 'MM/DD/YYYY'); //try to parse text as date

                      let newDate = mmnt.toDate();

                      if (isNaN(newDate)) {
                        throw new Error('invalid date');
                      }
                      newState.selectedDay = newDate;
                    } catch (error) {
                    } finally {
                      newState.dateText = evt.target.value;
                      this.setState(newState);
                    }
                  }}
                  onFocus={(evt) => {
                    let dateText;
                    try {
                      let mmnt = moment(this.state.selectedDay);
                      dateText = mmnt.format('MM/DD/YYYY');
                    } catch (error) {
                    } finally {
                      this.setState({ dateText: dateText, dateWindowActive: true, timeWindowActive: false });
                    }
                  }}
                />
              </div>
              <div className={timeClass} ref={(ref) => (this.timeModalRef = ref)}>
                <input
                  type="text"
                  className="DeviceVersionView_Buttons_Schedule_Div_Left_Text"
                  value={this.state.timeText}
                  onChange={(evt) => {
                    let newState = {};
                    let mmnt = moment(evt.target.value, 'hh:mm a'); //try to parse text as time

                    newState.timeText = evt.target.value;
                    this.setState(newState);
                  }}
                  onFocus={(evt) => {
                    this.setState({ dateWindowActive: false, timeWindowActive: true });
                  }}
                />
                {this.state.timeWindowActive ? (
                  <div className="DeviceVersionView_Buttons_Schedule_Time_Modal_Div">
                    <ul className="DeviceVersionView_Buttons_Schedule_Time_List Global_Modal_Shadow">
                      <PerfectScrollbar>
                        {Object.keys(hour_list).map((item) => (
                          <li
                            key={item}
                            onClick={() => {
                              this.selectTimeOnClick(item);
                            }}
                          >
                            <div>{item}</div>
                          </li>
                        ))}
                      </PerfectScrollbar>
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="DeviceVersionView_Buttons_Schedule_Div_Right">
              {this.props.actionPending ? (
                <button
                  className={'DeviceVersionView_Buttons_Apply Global_RoundedButton DeviceVersionView_Buttons_Install'}
                >
                  <img
                    alt="loading icon"
                    className="DeviceConfigTable_Status_LoadingIcon"
                    src={IconLoader.icon_spinner_small}
                  />
                </button>
              ) : (
                <button
                  className={'DeviceVersionView_Buttons_Apply Global_RoundedButton DeviceVersionView_Buttons_Install'}
                  disabled={!this.state.dateValid}
                  onClick={() => {
                    try {
                      let datetime = moment(this.state.dateText);
                      let mmntTime = moment(this.state.timeText, 'hh:mm a');

                      datetime.hour(mmntTime.hour());
                      datetime.minute(mmntTime.minute());

                      this.props.applyScheduleOnClick(
                        this.props.availableSwVersionList &&
                          this.props.availableSwVersionList[this.state.selectedIndex].sw_identifier,
                        datetime
                      );
                    } catch (error) {}
                  }}
                >
                  Schedule it
                </button>
              )}
            </div>
          </div>
        );
        break;
      default:
        break;
    }
    switch (this.state.stage) {
      case 'CALENDAR':
        calender = (
          <div className="SoftwareDownloadScheduler_CalendarDiv">
            <div className="SoftwareDownloadScheduler_CalendarTitle">Select a date and time</div>
            {buttons2}
            {!this.state.dateValid ? (
              <div className="SoftwareDownloadModal_InvalidTime_Div">
                <div className="SoftwareDownloadModal_InvalidTime_Icon_Div">
                  <img src={IconLoader.icon_error_s} alt="error icon" />
                </div>
                <div className="SoftwareDownloadModal_InvalidTime_Text">The selected time is in the past</div>
              </div>
            ) : null}
            <DayPicker
              className="SoftwareDownloadScheduler_DayPicker"
              numberOfMonths={1}
              selectedDays={this.state.selectedDay}
              month={this.state.selectedDay}
              onDayClick={this.handleDayClick}
            />
          </div>
        );
      //falls through, if calender mode, then fill both
      case 'LIST':
        let swVersions = this.props.softwareVersions['all'];
        list = (
          <DeviceVersionList
            close={this.props.close}
            installNowOnClick={this.props.installNowOnClick}
            modalPage={this.props.modalPage}
            softwareVersions={swVersions}
            selectIndex={(index) => this.setState({ selectedIndex: index })}
            selectedIndex={this.state.selectedIndex}
            availableSwVersionList={this.props.availableSwVersionList}
            allSwVersionList={this.props.softwareVersions?.['all']}
          />
        );
        break;
      default:
        break;
    }

    return (
      <Modal
        closeTargetRef={this.props.modalTargetRef}
        close={this.props.afterModalClose} //note that this only runs if you close the modal using the "closing" prop
        animate={this.props.animateModalClose}
        animateX={false}
        global
        closing={this.props.closeModal}
        height={this.state.stage === 'CALENDAR' || this.props.deviceList ? 540 : null}
        width={this.props.deviceList ? 700 : 378}
      >
        {this.props.getProductTypesListStatus === Status.PENDING && <div>{LOADING_CIRCLE}</div>}
        {this.props.getProductTypesListStatus === Status.FAILURE && (
          <div className="SoftwareDownloadModal_FailMessage">Cannot get product type information</div>
        )}
        {this.props.getProductTypesListStatus === Status.SUCCESS && (
          <form
            id="singleUpgradeForm"
            name="singleUpgradeFormName"
            className="SoftwareDownloadModalContent_OuterDiv"
            onClick={(evt) => {
              if (this.state.timeWindowActive && this.timeModalRef && !this.timeModalRef.contains(evt.target)) {
                this.setState({ timeWindowActive: false, dateWindowActive: true });
              }
            }}
          >
            {this.props.deviceList ? (
              <div className="SoftwareDownloadModal_DeviceList_Div">
                <div className="SoftwareDownloadModal_DevicesSelected_Div">
                  <span className="SoftwareDownloadModal_DevicesSelected_Number">
                    {this.props.deviceList.length + ' '}
                  </span>
                  <span>device{this.props.deviceList.length > 1 ? 's' : ''} selected</span>
                </div>
                <div className="SoftwareDownloadModal_SearchBar_Div">
                  <div className="SoftwareDownloadModal_SearchBar_InnerDiv">
                    <SearchBar
                      defaultText={'Search'}
                      searchQuery={(str) => {
                        this.setState({ searchString: str });
                      }}
                    />
                  </div>
                </div>
                <div className="SoftwareDownloadModal_DeviceList_InnerDiv">
                  <PerfectScrollbar>
                    <ul className="SoftwareDownloadModal_DeviceList">
                      {this.props.deviceList.map((item) => {
                        return (
                          <li
                            key={item}
                            className={classNames({
                              SoftwareDownloadModal_DeviceItem_Hidden:
                                this.state.searchString !== '' && !item.includes(this.state.searchString)
                            })}
                          >
                            {item}
                          </li>
                        );
                      })}
                    </ul>
                  </PerfectScrollbar>
                </div>
              </div>
            ) : null}
            <div className={'SoftwareDownloadModalContent'}>
              {list}
              <div className={'DeviceVersionView_Buttons'}>
                <button className={'DeviceVersionView_Buttons_Cancel'} onClick={this.props.cancelOnClick}>
                  Cancel
                </button>
                {buttons1}
              </div>
              {calender}
            </div>
          </form>
        )}
      </Modal>
    );
  }
}

export default SoftwareDownloadModal = connect((store) => {
  return {
    productTypesList: store.data.productTypesList,
    getProductTypesListStatus: store.statuses['GET-ProductTypesList']
  };
})(SoftwareDownloadModal);
